import React, { useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { /* InputBase, IconButton, */ makeStyles } from "@material-ui/core";
// import SearchIcon from "@material-ui/icons/Search";
// import useStyles from "../../styles/appBarRightStyle";
// import { useTranslation } from "../../langs/useTranslation";
import { useTranslation } from "@/langs/useTranslation";
import SearchInput from "../SearchInput";
import SingleSelector from "../SingleSelector";

const useStyles = makeStyles(theme => ({
  searchType: {
    marginRight: 0,

    "& .MuiOutlinedInput-root": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },

    "& .MuiOutlinedInput-notchedOutline": {
      borderRightColor: "rgba(0, 0, 0, 0.115)"
    }
  },
  searchInput: {
    marginLeft: -1,

    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },

    "& .MuiOutlinedInput-notchedOutline": {
      borderLeftColor: "rgba(0, 0, 0, 0.115)"
    }
  }
}));

export const getSearchTypes = t => {
  return [
    { name: t({ defaultMessage: "设备SN" }), id: "deviceSN" },
    { name: t({ defaultMessage: "设备名称" }), id: "deviceName" },
    { name: t({ defaultMessage: "设备描述" }), id: "description" },
    { name: t({ defaultMessage: "设备ID" }), id: "deviceId" }
  ];
};

const SearchBar = () => {
  const history = useHistory();
  // const { t } = useTranslation("common");
  const [searchValue, setSearchValue] = useState("");
  const [searchType, setSearchType] = useState("deviceSN");
  const { t, userLanguage } = useTranslation();
  const classes = useStyles();

  const handleSearchValue = e => {
    setSearchValue(e.target.value);
  };

  const handleSearchValueSubmit = () => {
    history.push(
      `/groups/groups-devices?search=${searchValue}&searchType=${searchType}&full_search=1`
    );
  };

  const serarchTypes = useMemo(() => {
    return getSearchTypes(t);
  }, [userLanguage]);

  return (
    <>
      <SingleSelector
        options={serarchTypes}
        clearable={false}
        value={searchType}
        className={classes.searchType}
        onChange={e => {
          setSearchType(e.target.value);
        }}
      />
      <SearchInput
        placeholder={t({ defaultMessage: "跨公司搜设备" })}
        value={searchValue}
        onChange={handleSearchValue}
        onPressEnter={handleSearchValueSubmit}
        className={classes.searchInput}
      />
    </>
  );

  // return (
  //   <div className={classes.search}>
  //     <IconButton
  //       aria-label="Search"
  //       color="inherit"
  //       onClick={handleSearchValueSubmit}
  //       className={classes.searchIcon}
  //     >
  //       <SearchIcon />
  //     </IconButton>
  //     <InputBase
  //       onKeyPress={e => {
  //         if (e.key === "Enter") {
  //           handleSearchValueSubmit();
  //         }
  //       }}
  //       placeholder={t("appbar.searchFieldText")}
  //       onChange={e => handleSearchValue(e)}
  //       classes={{
  //         root: classes.inputRoot,
  //         input: classes.inputInput
  //       }}
  //       inputProps={{ "aria-label": "search" }}
  //     />
  //   </div>
  // );
};

export default React.memo(SearchBar);
